import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./EditProductInCartForm";
import {GET_PRODUCT_IN_CART} from "../../queries/sales";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelEditProductInCart} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence, validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "productSku");
  errors = validateGreaterThan(errors, values, "quantity", 0);
  return errors.toJS();
}

class EditProductInCartFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changeProductQuantityInCart(values.set("accountId", this.props.accountId).toJS())
      .then((response) => {
        if (response.data.changeProductQuantityInCart.errors.length <= 0) {
          this.props.cancelEditProductInCart();
        } else {
          let errors = createValidationErrors(response.data.changeProductQuantityInCart.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleRemove(values) {
    let data = {accountId: this.props.accountId, productSku: this.props.productId}
    return this.props.removeProductFromCart(data)
      .then((response) => {
        if (response.data.removeProductFromCart.errors.length <= 0) {
          this.props.cancelEditProductInCart();
        } else {
          let errors = createValidationErrors(response.data.removeProductFromCart.errors);
          this.setState({errors: errors});
        }        
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelEditProductInCart();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const cartItem = fromJS(data.cartItem);
    let initialValues = {
      productSku: cartItem.get("productSku"),
      quantity: cartItem.get("quantity")
    }
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onRemove={this.handleRemove.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const REMOVE_PRODUCT_FROM_CART = gql`
  mutation removeProductFromCart($data: AccountProductInput!) {
    removeProductFromCart(input: $data) {
      errors { key message }
    }
  }
`;

const CHANGE_QUANTITY = gql`
  mutation changeProductQuantityInCart($data: AddToCartInput!) {
    changeProductQuantityInCart(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_PRODUCT_IN_CART, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId,
        productSku: props.productId
      }
    })
  }),
  graphql(REMOVE_PRODUCT_FROM_CART, {
    props: ({ mutate }) => ({
      removeProductFromCart: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(CHANGE_QUANTITY, {
    props: ({ mutate }) => ({
      changeProductQuantityInCart: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const EditProductInCartFormContainerWithData = withProductQuery(EditProductInCartFormContainer);

export default connect(null, {cancelEditProductInCart})(EditProductInCartFormContainerWithData);